import { render } from "./LoanListFilterPerPage.vue?vue&type=template&id=f865979c&scoped=true"
import script from "./LoanListFilterPerPage.vue?vue&type=script&lang=js"
export * from "./LoanListFilterPerPage.vue?vue&type=script&lang=js"

import "./LoanListFilterPerPage.vue?vue&type=style&index=0&id=f865979c&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f865979c"]])

export default __exports__